import { css } from 'styled-components';

export default () => css`
  .vjs-text-track-display > div > div {
    width: 100% !important;
  }
  .vjs-text-track-display > div > div {
    font: 3.5rem "IRANSans", sans-serif, serif !important;
    line-height: 6.5rem !important;
    > div {
      background-color: rgba(0,0,0,.6) !important;
      font: 3.5rem "IRANSans", sans-serif, serif !important;
      padding: 0 2rem;
      display: table !important;
      margin: 0 auto !important;
    }
  }
  .vjs-menu-item {
    font-family: "IRANSans", sans-serif, serif !important;
  }
  //.vjs-audio-button {
  //  display: block !important;
  //  margin: 0 .5rem;
  //}
  .vjs-tech {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  .vjs-poster {
    position: fixed;
    cursor: default;
  }
  .vjs-text-track-display {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    pointer-events: none;
    bottom: 0;
    margin: auto;
  }
  .vjs-big-play-button {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 9999999;
    cursor: pointer;
    border-radius: 10rem;
    border: none;
    overflow: hidden;
    background: rgba(255,255,255,.3);
    outline: none;
    width: 10rem;
    height: 10rem;
    font-size: 6.5rem;
    text-align: center;
    color: #fff;
    text-align: center;
    transition: none;
    &.active-item, &:hover {
      border: .5rem solid #ea1d5d  !important;
      background: #fff !important;
      color: #020100 !important;
      &:before {
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        line-height: 9.5rem;
      }
    }
    &:before {
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      line-height: 10.5rem;
    }
  }
  .video-js {
    font-size: 1.6rem;
    color: #cacaca;
    width: 100%;
    height: 100%;
    &.vjs-paused {
      .vjs-big-play-button {
        display: block !important;
      }
    }
  }
  .video-js .vjs-volume-menu-button {
    display: none;
  }
  .video-js .vjs-remaining-time {
    font-size: 2.5rem !important;
    line-height: 5.2rem;
    font-family: "IRANSans", sans-serif, serif;
  }
  .video-js .vjs-volume-menu-button .vjs-menu-content:before {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }
  .video-js .vjs-play-progress:after {
    font-family: "IRANSans", sans-serif, serif !important;
    font-size: 2rem !important;
    top: -4.5rem !important;
  }
  .video-js .vjs-mouse-display {
    &:after {
      font-family: "IRANSans", sans-serif, serif !important;
      font-size: 1.4rem !important;
    }
  }
  .video-js .vjs-volume-menu-button .vjs-menu-content .vjs-volume-bar {
    display: inline-block;
    vertical-align: middle;
  }
  .video-js .vjs-menu-content .vjs-texttrack-settings {
    display: none;
  }
  .video-js .vjs-control:before {
    font: normal normal normal 14px/1 FontAwesome;
    font-size: 3rem;
    padding: 1rem;
  }
  .video-js .vjs-control.vjs-play-control:before {
    content: '\f04b';
  }
  .video-js .vjs-control.vjs-play-control.vjs-playing:before {
    content: '\f04c';
  }
  .video-js .vjs-control.vjs-fullscreen-control:before {
    content: '\\f0b2';
  }
  .video-js .vjs-control.vjs-volume-menu-button:before {
    content: '\\f028';
  }
  .video-js .vjs-control.vjs-captions-button:before {
    content: '\\f0f6';
  }
  .video-js .vjs-control.vjs-audio-button:before {
    content: '\\f025';
    font-size: 3.7rem;
    padding: .85rem;
  }
  .video-js .vjs-control-bar,
  .video-js .vjs-big-play-button,
  .video-js .vjs-menu-button .vjs-menu-content {
    /* IE8 - has no alpha support */
    background-color: #262626;
    /* Opacity: 1.0 = 100%, 0.0 = 0% */
    background-color: rgba(38, 38, 38, 0.9);
  }
  .video-js .vjs-control-bar {
    background-color: rgba(38, 38, 38, 0.9);
    width: auto;
    left: 4em;
    right: 4em;
    bottom: 2em;
    border-radius: 0.5em;
  }
  .video-js .vjs-control-bar:hover .vjs-progress-control {
    opacity: 1;
  }
  .video-js .vjs-control-bar .vjs-menu {
    z-index: 2;
    height: 100%;
    margin-bottom: 0;
    bottom: 3rem;
  }
  
  .video-js.vjs-fullscreen .vjs-control-bar {
    bottom: 2em;
  }
  
  .video-js .vjs-current-time {
    display: block;
    position: absolute;
    right: 0;
    top: -2.4em;
    padding-right: 0;
    font-size: 1.8rem;
    font-family: "IRANSans", sans-serif, serif;
  }
  .video-js .vjs-slider {
    background-color: #2e2e2e;
    background-color: rgba(46, 46, 46, 0.8);
    border-radius: 1em;
    margin: 0;
  }
  
  .video-js .vjs-remaining-time {
    flex: 1;
    text-align: left;
  }
  .video-js .vjs-volume-level,
  .video-js .vjs-play-progress,
  .video-js .vjs-slider-bar {
    background: #cacaca;
    border-radius: 1em;
  }
  .video-js .vjs-play-progress {
    color: #df3268;
    background: #df3268;
    font-size: 1.3em;
  }
  .video-js .vjs-play-progress:before {
    transition: width .1s ease-out, height .1s ease-out;
    content: "";
    top: -.15rem;
    border: 0;
    background: #ea1d5d;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    box-shadow: #000 0 0 2px;
  }
  .video-js .vjs-play-progress:hover:before {
    width: 1.1em;
    height: 1.1em;
    border: 2px solid transparent;
  }
  
  .video-js .vjs-progress-control {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    width: calc(100% - 7rem);
    padding: 0;
    border-radius: 1em;
    transition: top 150ms linear, opacity 150ms linear, transform 150ms linear, -webkit-transform 150ms linear, -moz-transform 150ms linear, -o-transform 150ms linear;
    z-index: 1;
    top: -4rem;
  }
  .video-js .vjs-progress-control:hover .vjs-progress-holder {
    font-size: inherit;
  }
  .video-js .vjs-progress-control .vjs-mouse-display {
    background: #cacaca;
  }
  .video-js .vjs-progress-control .vjs-mouse-display:before {
    top: 100%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    border-top-color: #262626;
    border-width: .8em;
    right: 25%;
    margin-left: -.8em;
  }
  .video-js .vjs-play-progress,
  .video-js .vjs-load-progress {
    height: 0.7em !important;
  }
  .video-js .vjs-progress-holder {
    height: 0.9em;
  }
  .video-js .vjs-load-progress {
    background: #3a3a3a;
    background: rgba(46, 46, 46, 0.5);
    border-radius: 1em;
    height: 0.9em !important;
  }
  .video-js .vjs-load-progress div {
    background: #3a3a3a;
    background: rgb(253 60 99 / 25%);
    border-radius: 1em;
    height: 0.9em;
  }
  .vjs-seeking .vjs-loading-spinner:after,
  .vjs-waiting .vjs-loading-spinner:after {
    animation: vjs-spinner-spin 1.1s linear infinite, vjs-spinner-fade 1.1s linear 1 !important;
    animation-delay: 2s;
  }
  .vjs-seeking .vjs-loading-spinner,
  .vjs-waiting .vjs-loading-spinner {
    opacity: 1;
    visibility: visible;
    animation: vjs-spinner-fade-in 2s linear 1;
    animation-delay: 2s;
  }
  .vjs-loading-spinner {
    width: 10rem;
    height: 10rem;
    border-radius: 10rem;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border-width: 0.9rem;
    &:before {
      margin: -.9rem;
    }
    &:after {
      margin: -.9rem;
    }
  }
  @keyframes vjs-spinner-fade-in {
    0% {
      opacity: 0;
      visibility: visible;
    }
    100% {
      opacity: 1;
      visibility: visible;
    }
  }
  @keyframes vjs-spinner-fade-out {
    0% {
      opacity: 1;
      visibility: visible;
    }
    100% {
      opacity: 0;
      visibility: visible;
    }
  }
`;
